<template>
    <component :is="tag" class='smooth-reflow'>
        <slot/>
    </component>
</template>

<script>
    import smoothReflow from 'vue-smooth-reflow'

    export default {
        data() {
            return {
                options: {
                    property: 'height',
                    transition: 'height .3s ease-in-out',
                    // wait for transition on opacity to finish
                    transitionEvent: {
                        selector: 'div',
                        propertyName: 'opacity'
                    }
                }
            }
        },
        name: "SmoothReflow",
        mixins: [smoothReflow],
        props: {
            tag: {
                type: String,
                default: 'div'
            },
        },
        mounted() {
            this.$smoothReflow( this.options );
        }
    }
</script>

<style scoped lang="scss">
    .smooth-reflow {
        min-height: 200px;

        ::v-deep > * {
            height: auto;
        }
    }
</style>
